export default __webpack_public_path__ + "static/media/tax-1.7763607a.jpeg";